const Loading = () => (
  <div className="text-center">
    Loading
  </div>
);

export default Loading;
